export default function StreamInputDescDvb({ input }) {
  return <>DVB Service {input.sid} @ adapter {input.dvb_adapter_name || "UNKNOWN"}</>;
}
